import type { Optional } from '@festina-life/core'

import { LAYER_ID_TENANT_SEPARATOR } from './constants'

type ConstructorProps = {
  tenantId: Optional<string>
  layerId: Optional<string>
}

export class LayerKey {
  tenantId: string | null
  layerId: string | null

  constructor(propsString: string)
  constructor({ tenantId, layerId }: ConstructorProps)
  constructor(props: ConstructorProps | string) {
    if (typeof props === 'string') {
      if (!props.includes(LAYER_ID_TENANT_SEPARATOR)) {
        throw new Error('Invalid layer string')
      }
      const [layerId, tenantId] = props.split(LAYER_ID_TENANT_SEPARATOR)
      this.layerId = layerId || null
      this.tenantId = tenantId || null
    } else {
      this.tenantId = props.tenantId || null
      this.layerId = props.layerId || null
    }
  }

  equals(other: LayerKey): boolean {
    return (
      (this.layerId || null) === (other.layerId || null) &&
      (this.tenantId || null) === (other.tenantId || null)
    )
  }

  toString(): string {
    return `${this.layerId ?? ''}${LAYER_ID_TENANT_SEPARATOR}${this.tenantId ?? ''}`
  }
}
